import React, { useState, useEffect } from "react";
import { BackNextButton, UploadingInput, Button } from "../../../../../common";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import {
  useUpdateCompanyMutation,
  useUpdateCompanyDraftMutation,
  useUpdateCompanyRequestStatusMutation,
  useUpdateCompanyDraftEditMutation,
  useGetCompanyRequestStatusMutation,
  useFetchCompanyDraftEditMutation,
} from "../../../../../../store/Company/companyApiSlice";
import { SITE_URL } from "../../../../../../constants/apiUrls";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";
import { CommonToast } from "../../../../../common/Toast";
export const LogoBanner = ({ onPrev, onNext, onSkip }) => {
  const [previewUrlBanner, setPreviewUrlBanner] = useState(null);
  const [previewUrlLogo, setPreviewUrlLogo] = useState(null);
  const [uploadedBannerFile, setUploadedBannerFile] = useState(null);
  const [uploadedLogoFile, setUploadedLogoFile] = useState(null);
  const [logoError, setLogoError] = useState(null);
  const [bannerError, setBannerError] = useState(null);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [updateCompany, { isLoading }] = useUpdateCompanyMutation();
  const [UpdateCompanyDraft, { isLoadingDraft }] =
    useUpdateCompanyDraftMutation();
  const [UpdateCompanyDraftEdit, { isLoadingDraftEdit }] =
    useUpdateCompanyDraftEditMutation();
  const [FetchCompanyDraftEdit, { isLoadingFetchDraft }] =
    useFetchCompanyDraftEditMutation();

  const [companyVerificationStatus, setcompanyVerificationStatus] =
    useState("pending");
  const [requestID, setrequestID] = useState(null);
  const [getCompanyRequestStatus] = useGetCompanyRequestStatusMutation();
  const [updateCompanyRequestStatus] = useUpdateCompanyRequestStatusMutation();

  useEffect(() => {
    if (currentEditingCompany?.userCompany) {
      let userindividualID = localStorage.getItem("userindividualID");

      const companyStatus = async () => {
        let dataval = await getCompanyRequestStatus({
          companyID: currentEditingCompany.companyID,
          individualID:
            userindividualID ||
            currentEditingCompany?.userCompany[0]?.individualID?.individualID,
          token,
        });
        if (dataval) {
          let statusValue = dataval.data?.filter(
            (item) =>
              item?.companyID?.companyID == currentEditingCompany.companyID
          );
          if (statusValue?.length > 0) {
            let companyStatus = statusValue[statusValue.length - 1];
            setcompanyVerificationStatus(companyStatus?.status);
            setrequestID(companyStatus?.requestID);
          }
        }
      };
      companyStatus();
    }
    if (currentEditingCompany && companyVerificationStatus == "Modified") {
      // Fetch Company Draft API
      fetchDraftDetails();
    } else if (currentEditingCompany) {
      setPreviewUrlLogo(currentEditingCompany.logo);
      setPreviewUrlBanner(currentEditingCompany.banner);
    }
  }, [currentEditingCompany, companyVerificationStatus]);
  const fetchDraftDetails = async () => {
    try {
      const fetchDraft = await FetchCompanyDraftEdit({
        companyId: currentEditingCompany.companyID,
        token,
      }).unwrap();
      if (fetchDraft?.data) {
        if (fetchDraft?.data[0]?.logo) {
          setPreviewUrlLogo(`${SITE_URL}/media/` + fetchDraft?.data[0]?.logo);
        } else {
          setPreviewUrlLogo(currentEditingCompany.logo);
        }
        if (fetchDraft?.data[0]?.banner) {
          setPreviewUrlBanner(
            `${SITE_URL}io/media/` + fetchDraft?.data[0]?.banner
          );
        } else {
          setPreviewUrlBanner(currentEditingCompany.banner);
        }
      }
    } catch (error) {

    }
  };

  const handleBannerUpload = (file) => {
    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = () => {
        const width = image.width;
        const height = image.height;
        if (width == 1200 && height == 200) {
          setUploadedBannerFile(file);
          setBannerError(null);
          // preview image
          if (file && file.type.match("image.*") && !uploadedBannerFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
              setPreviewUrlBanner(e.target.result);
            };
            reader.readAsDataURL(file);
          } else {
            setPreviewUrlBanner(null);
          }
        } else {
          setUploadedBannerFile(null);
          setBannerError(
            "Please select an Banner with dimensions 1200px x 200px."
          );
        }
      };
    }

  };

  const handleRemoveLogo = () => {
    setPreviewUrlLogo(null);
    setLogoError(null);
    setUploadedLogoFile(null);
  };

  const handleRemoveBanner = () => {
    setPreviewUrlBanner(null);
    setBannerError(null);
    setUploadedBannerFile(null);
  };

  const handleLogoUpload = (file) => {
    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const width = image.width;
        const height = image.height;
        if (width === 134 && height === 134) {
          setUploadedLogoFile(file);
          setLogoError(null);
          // preview image
          if (file && file.type.match("image.*") && !uploadedLogoFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
              setPreviewUrlLogo(e.target.result);
            };
            reader.readAsDataURL(file);
          } else {
            setPreviewUrlLogo(null);
          }
        } else {
          setUploadedLogoFile(null);
          setLogoError("Please select an Logo with dimensions 134px x 134px.");
        }
      };
    }


  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    // Submit the form if no errors
    if (Object.keys(errors).length === 0) {
      try {
        const formData = new FormData();
        if (uploadedBannerFile != null) {
          const bannerUrl = await uploadFileToS3(
            uploadFilePath?.banner,
            uploadedBannerFile,
            token,
            userInfo?.id
          );
          formData.append("banner", bannerUrl?.url);
        }
        if (uploadedLogoFile != null) {
          const logoUrl = await uploadFileToS3(
            uploadFilePath?.logo,
            uploadedLogoFile,
            token,
            userInfo?.id
          ); // Await here to get the logo URL
          formData.append("logo", logoUrl?.url);
        }
        formData.append(
          "banner_logo_license_status",
          currentEditingCompany.banner_logo_license_status == "Requested"
            ? "Requested"
            : "Modified"
        );
        const res = await updateCompany({
          data: formData,
          token,
          companyId: currentEditingCompany.companyID,
        }).unwrap();
        if (res?.companyID) {
          dispatch(setCurrentEditingCompany(res));
          onNext(0, "License Information", "Details");
        }
      } catch (error) {
        CommonToast.error(error)
        onNext(0, "License Information", "Details");
      }
    }

  };
  return (
    <div className="relative w-half h-half">
      <div className="mt-5 mr-20">
        <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
          Add company logo & banner
        </h3>
        <div className="border border-slate rounded-lg p-8 mb-6">
          {/* company banner  */}
          <div className="flex flex-col w-full mb-6">
            <label className="block mb-1 text-primary text-f14 font-semibold text-left">
              Company Banner
            </label>

            {!previewUrlBanner ? (
              <>
                <UploadingInput
                  uploadError={bannerError ? true : false}
                  onFileSelect={(file) => {
                    handleBannerUpload(file);
                  }}
                />
                <br />
                {bannerError && (
                  <h6 style={{ color: "red", fontSize: "12px" }}>
                    {bannerError}
                  </h6>
                )}
              </>
            ) : (
              <div className="bannerSection">
                <img
                  className="bannerImg"
                  src={previewUrlBanner}
                  alt="company banner"
                />
                <Button
                  onClick={handleRemoveBanner}
                  classes=" relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 "
                >
                  <span>Change Banner</span>
                </Button>
              </div>
            )}
          </div>
          <div className="flex flex-col w-full mb-6">
            <label className="block mb-1 text-primary text-f14 font-semibold text-left">
              Company Logo
            </label>
            {!previewUrlLogo ? (
              <>
                <UploadingInput
                  uploadError={logoError ? true : false}
                  onFileSelect={(file) => {
                    handleLogoUpload(file);
                  }}
                />
                <br />
                {logoError && (
                  <h6 style={{ color: "red", fontSize: "12px" }}>
                    {logoError}
                  </h6>
                )}
              </>
            ) : (
              <div className="bannerSection">
                <img
                  className="bannerImg"
                  src={logoError ? null : previewUrlLogo}
                  alt="company banner"
                />
                <Button
                  onClick={handleRemoveLogo}
                  classes=" relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 "
                >
                  <span>Change Logo</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <BackNextButton
        onPrev={() => onPrev(3, "Social Media")}
        onNext={handleSubmit}
        onSkip={() => onSkip(0, "License Information", "Details")}
        isLoading={isLoading}
      />
    </div>
  );
};
